import { Box, Icon, SecondaryButton, Typography } from "@husqvarna/ui-core";
import { FormattedMessage, useIntl } from "react-intl";

export type NoSiteProps = {
    onGoToSiteClick?: () => void;
};

const NoSite = ({
    onGoToSiteClick
}: NoSiteProps) => {
    const intl = useIntl();
    return (
        <Box
            alignItems="center"
            flexDirection="column"
            textAlign="center"
            flexGrow={1}
            py={12}
            px={6}
        >
            <Icon color="ErrorRed" iconId="info" size={8} mb={8}></Icon>
            <Typography variant="Heading4" tag="h4">
                <FormattedMessage
                    id="projects.equipment.noSiteHeading"
                    defaultMessage="Create area"
                />
            </Typography>
            <Typography variant="Body1" tag="p" mt={3}>
                <FormattedMessage
                    id="projects.equipment.noSiteText"
                    defaultMessage="To be able to add equipment to the new setup you first need to create area."
                />
            </Typography>
            <SecondaryButton
                mt={8}
                onClick={onGoToSiteClick}
                text={intl.formatMessage({
                    id: "projects.equipment.noSiteButton",
                    defaultMessage: "Create area",
                })}
            />
        </Box>
    );
};
export default NoSite;